<template>
  <b-modal
    body-class="padding"
    button-size="sm"
    title="Create new surgeon"
    title-tag="h5"
    cancel-title="Cancel"
    id="idBranchDetailNewSurgeonModal"
    cancel-variant="outline-primary"
    :ok-title="this.$store.state.surgeon ? 'Update' : 'Create'"
    size="md"
    :ok-disabled="firstName === null || lastName === null"
    @shown="focusFirstInput"
    @show="onShow"
    @hidden="clearData"
    @ok="onOk"
  >
    <div class="padding">
      <b-row>
        <label class="required" for="idFirstName">First Name</label>
        <b-form-input
          size="sm"
          id="idFirstName"
          trim
          ref="firstInput"
          v-model="firstName"
        ></b-form-input>
      </b-row>
      <b-row>
        <label class="required" for="idLastName">Last Name</label>
        <b-form-input
          size="sm"
          id="idLastName"
          trim
          v-model="lastName"
        ></b-form-input>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      firstName: null,
      lastName: null,
    };
  },
  methods: {
    focusFirstInput() {
      this.$refs.firstInput.focus();
    },
    onShow() {
      if (this.$store.state.surgeon) {
        this.id = this.$store.state.surgeon.id;
        this.firstName = this.$store.state.surgeon.firstName;
        this.lastName = this.$store.state.surgeon.lastName;
      }
    },
    onOk() {
      if (this.$store.state.surgeon) {
        this.$emit("updateSurgeon", {
          id: this.$store.state.surgeon.id,
          firstName: this.firstName,
          lastName: this.lastName,
        });
      } else {
        this.$emit("newSurgeon", {
          firstName: this.firstName,
          lastName: this.lastName,
        });
      }
    },
    clearData() {
      this.$store.commit("SET_SURGEON_TO_EDIT", null);
      this.firstName = null;
      this.lastName = null;
    },
  },
};
</script>

<style scoped>
.padding {
  padding: 1rem 3rem;
}
.row {
  margin: 0.8rem 0;
}
</style>